import {
  ApiRoute,
  Newsletter,
  NewsletterSchema,
  SubscriptionRequest,
  UploadImageResp,
  UploadImageRespSchema,
  getApiRoute
} from "@garther/interfaces";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

class PublicApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.PUBLIC),
      requireAuth: false
    });
  }

  async subscribeToNewsletter(request: SubscriptionRequest): Promise<Newsletter> {
    return await this.post("subscribe", NewsletterSchema, request, {
      requireAuth: false
    });
  }

  uploadImage = async (file: File): Promise<UploadImageResp> => {
    const formData = new FormData();
    formData.append("image", file);

    return await this.post("image", UploadImageRespSchema, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      requireAuth: true
    });
  };
}

export const publicApiClient = new PublicApiClient();
